export default defineNuxtPlugin(() => {
  if (import.meta.server || !useRuntimeConfig().public.gtmEnabled) return

  const { beforeEach } = useRouter()
  const { reset } = useTrackingFieldSingleton()

  beforeEach(reset)
})
